import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '../css/Register.css';
import Vas from '../Vas';
import { ExtendedButton,Loading,MessageBox } from "component-lib";
import { AccountsModel, EmailModel,RequestAjaxClass } from 'models-lib';

class ActivateEMail  extends Component {

  constructor(props)
  {
    super(props);
    this.state = {};
    let token = decodeURIComponent(window.location.pathname.split('/changeMail/')[1]);
    this.state.Id = token;
    this.AccountsModel = new AccountsModel([this]);
    this.EmailModel = new EmailModel([this]);
    this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    this.curToken = '';
  }

  componentDidMount(){

    this.Request.setAuth(false);
    this.Request.setApiKey(Vas.ApiKey);
    this.Request.setApiUrl(Vas.ApiUrl);
    this.Request.setErrorHandler(()=>{
      ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
      ReactDOM.render(<MessageBox 
        AppURL={Vas.ApplicationUrl}  
        Title={Vas.Resources.Titles["Note"]} 
        Message={Vas.Resources.Labels["EmailNotChanged"]} 
        />,document.getElementById('messageContainer'));
    });

    this.AccountsModel.SetRequest(this.Request);
    this.EmailModel.SetRequest(this.Request);
  }

  Update(observer){
    let me = this;
    this.setState({},()=>{
      if(observer === "ActivateChangeMail"){
        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        localStorage.setItem('vas_token',me.curToken);
        if (me.curToken !== null){
          me.Request.setErrorHandler(()=>{
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl}  
              Title={Vas.Resources.Titles["Note"]} 
              Message={Vas.Resources.Labels["ActivateEmail"] +" " + Vas.Resources.Labels["ButDataError"]} 
              />,document.getElementById('messageContainer'));
          });
          me.Request.setAuth(true);
          me.AccountsModel.Own();
        } else {
          Vas.clearLocalStorage();
          Vas.GetView("ActivateEMailSuccessOffline",null,false);
        }
      }
      else if( observer === "AccountsOwn"){
        localStorage.setItem("vas_customerId", me.AccountsModel.Customer.Id);
        Vas.GetView("ActivateEMailSuccess",null,true);
      }
    });
  }
  confirmEmail()
  {
    ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));

    this.curToken = localStorage.getItem('vas_token');
    localStorage.setItem('vas_token',this.state.Id);

    this.EmailModel.ActivateChangeEmail();
  }

  render()
  {
    return (
      <div className={"RegisterContainer"}>
        <div className={"form"}>
          <h2> { Vas.Resources.Titles["Activation"] }</h2>
          <div>
            <table>
              <tbody>
                <tr>
                  <td>
                    {Vas.Resources.Labels["ConfirmEmail"]}
                    <br/>
                  </td>                  
                </tr>
                <tr>
                  <td>
                    <br/>
                    <ExtendedButton
                      Float={'left'} 
                      OnClick={()=>{this.confirmEmail();}}
                      Text={Vas.Resources.Labels["Confirm"]}
                      Usable={true} 
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default ActivateEMail;
